$(document).ready(function () {

const currentUrl = window.location.href;
console.log(currentUrl,'currentUrl>>>>>>>');
  // Remove 'active' from all links, then add to the matching one
  $(".option_link").each(function () {
    if (this.href === currentUrl) {
      $(this).parents('.option_value').addClass("active");
      console.log(this.href,'this.href>>>>>');
    }
  });
  
  setTimeout(function () {
    if ($(".samples__list").length >= 1) {
      $(".error_too_much").show();
    }
  }, 1000);

  $(document).on("click", ".header__icon--cart", function (event) {
    event.preventDefault();
    $("cart-drawer.drawer").addClass("active");
  });

  checkCartForItems();
  product_slick_slider();

  $(document).on("click", ".mobile-close-wrap", function () {
    $(this).closest(".menu-drawer-container").removeClass("menu-opening");
    $(this)
      .parents(".menu-drawer-container")
      .find(".header__icon--menu")
      .attr("aria-expanded", false);
    $("body").removeClass("overflow-hidden-tablet");
  });

  $(".header__menu-item").hover(
    function () {
      // Mouse enters: Add attribute
      console.log("hovered");
      $(this).parents("details").attr("open", "true");
      $(this).parents("details").addClass("submenu-opened");
      $(this).attr("aria-expanded", "true");
    },
    function () {
      // Mouse leaves: Remove attribute
      // $(this).parents('.mega-menu').removeAttr('open');
      $(this).parents("details").removeClass("submenu-opened");
      $(this).attr("aria-expanded", "true");
    }
  );

  $(".header__menu-item, .mega-menu__content").hover(
    function () {
      $(this).parents(".header-wrapper").addClass("menu-opened");
    },
    function () {
      $(this).parents(".header-wrapper").removeClass("menu-opened");
    }
  );

  if ($(window).width() > 767) {
    $(".video_slide").slick({
      draggable: true,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="slick-next pull-right">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
        '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
        "</svg></button>",
      nextArrow:
        '<button type="button" class="slick-prev pull-left">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
        '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
        "</svg>" +
        "</button>",
      dots: true,
      infinite: true,
    });
  } else {
    $(".video_slide").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,

      responsive: [
        {
          breakpoint: 749,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
    $(".iwtt--items").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
    });
  }
  $(".product--instructions_image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    dots: true,
    prevArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg></button>",
    nextArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg>" +
      "</button>",
  });
  // Cache selectors
  const $window = $(window);
  const $vcSlides = $(".vc-slide");
  const $vcContentWraps = $(".vc-content-wrap");
  const $productInstructionsLinks = $(".product_instructions-link");
  const $tabLinks = $(".tab_link");
  const $productDimensionLinks = $(".product_dimension-link");
  const $productStructureLineks = $(".product_structure-link");
  // Scroll event optimization
  $(window).on("scroll", function () {
    var mostVisible = null;
    var maxVisibleArea = 0;
    $(".vc-content-wrap").each(function () {
      const $this = $(this);
      const elementTop = $this.offset().top;
      const elementBottom = elementTop + $this.outerHeight();
      const viewportTop = $(window).scrollTop();
      const viewportBottom = viewportTop + $(window).height();
      const visibleTop = Math.max(elementTop, viewportTop);
      const visibleBottom = Math.min(elementBottom, viewportBottom);
      const visibleArea = Math.max(0, visibleBottom - visibleTop);

      // Track the most visible .vc-content-wrap based on the area visible in the viewport
      if (visibleArea > maxVisibleArea) {
        maxVisibleArea = visibleArea;
        mostVisible = $this;
      }
    });
    if (mostVisible) {
      // Reset all active classes
      $(".vc-content-wrap").removeClass("is-active");
      $(".vc-imges").removeClass("is-active");
      mostVisible.addClass("is-active");
      const targetId = mostVisible.data("target");
      $("#" + targetId).addClass("is-active");
    }
  });

  handleLinkActivation($tabLinks, $(".product-tab_content"));
  handleLinkActivation($productDimensionLinks, $(".product--dimensions_image"));
  handleLinkActivation($productStructureLineks, $(".product--structure_image"));

  $(".product_instructions-link").on("click", function () {
    const $this = $(this);
    const targetId = $this.attr("id");
    $(".product_instructions-link").removeClass("active");
    $this.addClass("active");
    $(".product--instructions_image").hide().removeClass("active");
    $(`.product--instructions_image[data-target="${targetId}"]`)
      .show()
      .addClass("active");
    $(".product--instructions_image").slick("refresh");
  });

  $(".current_option").hover(function () {
    $(".mob_sort-by-content").show();
  });

  $(".faq-acc__link").click(function () {
    var target = $(this).attr("data-target");
    console.log("#" + target, "target>>>");
    $("html, body").animate(
      {
        scrollTop: $("#" + target).offset().top,
      },
      500
    );
    return false;
  });
  $(".faq_tab--link").click(function () {
    $(this).toggleClass("active");
    var $content = $(this).next(".faq_tab-content");
    $content.slideToggle();
    $(".faq_tab-content").not($content).slideUp(); // Close all other contents
    $(".faq_tab--link").not(this).removeClass("active"); // Remove active class from other tabs
  });

  $(".cm__content-title").click(function () {
    $(this).toggleClass("active");
    var $content = $(this)
      .parents(".cm__content--item-wrap")
      .find(".cm__content--item-bottom-pdf-wrapper");
    $content.slideToggle();
    // $('.cm__content--item-bottom-pdf-wrapper').not($content).slideUp(); // Close all other contents
    $(".cm__content-title").not(this).removeClass("active"); // Remove active class from other tabs
  });

  var checkedValue = localStorage.getItem("selectedRadio");
  if (checkedValue) {
    toggleCustomAttrWrapElements();
    $(".toggle__input[value='" + checkedValue + "']").prop("checked", true);
  }

  $(".toggle__input").on("change", function () {
    var selectedValue = $(this).val();
    if ($(this).prop("checked")) {
      localStorage.setItem("selectedRadio", selectedValue);
      console.log(selectedValue, "selected");
      toggleCustomAttrWrapElements();
    } else {
      localStorage.removeItem("selectedRadio");
      $('.custom_attr_wrap').show();
      console.log("unchecked");
    }
    location.reload();
  });

  $(document).on("change", "#select__id", function () {
    var $el = $(this),
      $selected = $el.find(":selected"),
      id = $selected.attr("data-id"),
      $wrap = $("#variant_picker__custom--main"),
      form_id = $wrap.attr("data-form_id"),
      available = $selected.attr("data-available") === "true",
      v = $selected.attr("data-variant"),
      vj = v ? JSON.parse(v) : null;

    console.log(vj, "<<<<variant");
    if (!v) {
      return;
    }
    $("#" + form_id)
      .find('[name="id"]')
      .val(id);
    toggleAddButton(form_id, !available, window.variantStrings.soldOut);
  });

  $(document).on(
    "change",
    ".variant_picker__custom .product-form__input input",
    function () {
      var $el = $(this),
        $wrap = $el.closest(".variant_picker__custom"),
        checked_arr = [],
        $hSelect = $("#select__id");
      $wrap.find(".product-form__input").each(function () {
        let $e = $(this),
          $input = $e.find("input:checked"),
          val = $input.val();
        checked_arr.push(val);
      });
      let v_title = checked_arr.join(" / ");
      $hSelect.val(v_title).change();
      console.log(checked_arr, v_title);
    }
  );

  $(document).on("change", ".vpc_swatch_input", function () {
    trigger_select("input");
  });

  $(document).on("change", ".vpc_swatch_select", function () {
    trigger_select("select");
  });
}); //ready

function trigger_select(type = "input") {
  var options_len = $(".variant_picker__custom .product-form__input").length,
    opts = "",
    opt1 = "",
    opt2 = "",
    opt3 = "";
  if (type == "input") {
    (opt1 = $(
      '.variant_picker__custom [data-option="option1"] .vpc_swatch_input:checked'
    ).val()),
      (opt2 = $(
        '.variant_picker__custom [data-option="option2"] .vpc_swatch_input:checked'
      ).val()),
      (opt3 = $(
        '.variant_picker__custom [data-option="option3"] .vpc_swatch_input:checked'
      ).val());
  } else {
    (opt1 = $(
      '.variant_picker__custom [data-option="option1"] .vpc_swatch_select'
    ).val()),
      (opt2 = $(
        '.variant_picker__custom [data-option="option2"] .vpc_swatch_select'
      ).val()),
      (opt3 = $(
        '.variant_picker__custom [data-option="option3"] .vpc_swatch_select'
      ).val());
  }
  if (options_len == 1) {
    opts = opt1;
  } else if (options_len == 2) {
    opts = opt1 + " / " + opt2;
  } else if (options_len == 3) {
    opts = opt1 + " / " + opt2 + " / " + opt3;
  }
  // console.log(type, 'opts>>>', opts)
  $("#select__id").val(opts).change();
}

function toggleAddButton(form_id, disable = true, text, modifyClass = true) {
  const productForm = document.querySelector(`#${form_id}`);
  if (!productForm) return;
  const addButton = productForm.querySelector('[name="add"]');
  const addButtonText = productForm.querySelector('[name="add"] > span');
  if (!addButton) return;

  if (disable) {
    addButton.setAttribute("disabled", "disabled");
    if (text) addButtonText.textContent = text;
  } else {
    addButton.removeAttribute("disabled");
    addButtonText.textContent = window.variantStrings.addToCart;
  }
}

function toggleCustomAttrWrapElements() {
  $(".product-form__input--swatch .custom_attr_wrap").each(function () {
    var avlValue = $(this).attr("data-avl"); // Get the data-avl attribute value
    if (avlValue === "true") {
      $(this).show(); // Show the element if data-avl is "true"
    } else {
      $(this).hide(); // Hide the element if data-avl is not "true"
    }
  });
}
// Generalized function for handling tab/link activation
function handleLinkActivation($links, $content, dataAttribute) {
  $links.on("click", function () {
    const $this = $(this);
    const targetId = $this.attr("id");
    $links.removeClass("active");
    $this.addClass("active");
    // Hide all content and remove active class
    $content.hide().removeClass("active");
    // Show the target content and add active class
    $content.filter(`[data-target="${targetId}"]`).show().addClass("active");
    $(".product--instructions_image").slick("refresh");
  });
}

// Initialize the Slick Sliders
function product_slick_slider() {
  $(".product-slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    asNavFor: ".product-slider-nav",
    responsive: [
      {
        breakpoint: 500,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".product-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg></button>",
    nextArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg>" +
      "</button>",
    vertical: false,
    infinite: false,
    asNavFor: ".product-slider-for",
    focusOnSelect: true,
  });
}

$(".product-slider-for").on("init", function (event, slick) {
  setTimeout(function () {
    filterSliders(
      $(".product-form__input--swatch input[type=radio]:checked").val()
    );
  }, 1000);
});

function filterSliders(var_place) {
  console.log(var_place, "var_place"); // This looks like a debug log, make sure you define var_place
  var $sliderFor = $(".product-slider-for"),
    $sliderNav = $(".product-slider-nav");

  if (
    $sliderFor.hasClass("slick-initialized") &&
    $sliderNav.hasClass("slick-initialized")
  ) {
    // First, unfilter all slides
    $sliderFor.slick("slickUnfilter");
    $sliderNav.slick("slickUnfilter");

    try {
      setTimeout(function () {
        $sliderFor.slick("slickFilter", "." + var_place);
        $sliderNav.slick("slickFilter", "." + var_place);
        console.log("Filtered sliders based on>>>>>>>>>>>", var_place);
        $(".sslick__slider__media").removeClass("loading-gallery");
      }, 800);
    } catch (error) {}
  }
}

$(document).on("change", ".product-form__input--pill", function () {
  $(".sslick__slider__media").addClass("loading-gallery");
  setTimeout(function () {
    $(".swatch-input__input").eq(0).click();
    $(".product-slider-for").slick("refresh");
    $(".product-slider-nav").slick("refresh");
    $(".sslick__slider__media").removeClass("loading-gallery");
  }, 8000);
});

$(document).on("change", ".product-form__input", function () {
  let variant = $(".swatch-input__input:checked").val();
  var $sliderFor = $(".product-slider-for"),
    $sliderNav = $(".product-slider-nav");
  $(".sslick__slider__media").addClass("loading-gallery");
  setTimeout(function () {
    $(".product-slider-for").slick("slickGoTo", 0); // Go to the first slide
    $(".thumbnail-list__item").each(function (index) {
      $(this).attr("data-slick-index", index);
    });
  }, 8000);

  if (
    $sliderFor.hasClass("slick-initialized") &&
    $sliderNav.hasClass("slick-initialized")
  ) {
    $sliderFor.slick("slickUnfilter");
    $sliderNav.slick("slickUnfilter");

    try {
      setTimeout(function () {
        $sliderFor.slick("slickFilter", "." + variant);
        $sliderNav.slick("slickFilter", "." + variant);
        console.log("Filter applied for variant:", variant);
        $(".sslick__slider__media").removeClass("loading-gallery");
      }, 3000);
    } catch (error) {}
  }
});

$(".product-slider-nav, .product-slider-for").on(
  "afterChange",
  function (event, slick, currentSlide, nextSlide) {
    var $el = $(event.target),
      $wrap = $el.closest(".product__media-wrapper"),
      $current = $el.find(".slick-current.slick-active"),
      index = $current.data("slick-index"),
      $main = $wrap.find(".product-slider-for"),
      $thumb = $wrap.find(".product-slider-nav");

    // Remove aria-current from all thumbnails
    $thumb.find(".thumbnail").removeAttr("aria-current");
    // Add aria-current to the current thumbnail
    $thumb
      .find(`[data-slick-index="${index}"] .thumbnail`)
      .attr("aria-current", "true");
  }
);
// ### Sample page Drawer Js ###
$(document).on("click", ".formulas_checkboxes", function () {
  var $el = $(this),
    value = $el.val(),
    data_title = $el.attr("data-title"),
    image_src = $el.attr("data-src");

  // Get the current number of items in the list
  var itemCount = $(".samples__list").length;

  // Check if the checkbox is checked or unchecked
  if ($(this).prop("checked")) {
    if (itemCount < 5) {
      // Allow adding item only if fewer than 5 items are added
      // Change the label text to "Remove ?"
      $el.parents(".cmcnt--item-prd").find(".label_wrap").html("Remove ?");
      $el.parents(".prod_Checkbox").addClass("active-checkbox");

      // Create the new HTML element for the sample
      var newSampleHTML = `<div class="samples__list" data-id="${value}">
                                <div class="samples_list__samples_img">
                                    <img src="${image_src}" alt="${data_title}">
                                </div>
                                <div class="samples_list__samples_title">${data_title}</div>
                                <a href="#" class="remove_samples_from_list">x</a>
                              </div>`;

      // Append the new element to the list without removing previous items
      $(".sample_side-lists").append(newSampleHTML);
      $(".simple_drawer-wraper").show();

      // Hide the error message if the item is added successfully
      $(".error_too_much").hide();
    } else {
      // If more than 5 items are being added, show error message
      $(".error_too_much").show();
      // Uncheck the checkbox
      $el.prop("checked", false);
    }
  } else {
    // Update label text to "Order a sample"
    $el.parents(".cmcnt--item-prd").find(".label_wrap").html("Order a sample");
    $el.parents(".prod_Checkbox").removeClass("active-checkbox");
    var sampleId = $(this).val(); // Use the checkbox value to find the corresponding sample
    $('.sample_side-lists .samples__list[data-id="' + sampleId + '"]').remove();

    // Hide the error message when item is removed
    $(".error_too_much").hide();
  }
  toggleDrawerVisibility();
});

// Optional: Handling the removal of an item from the list
$(document).on("click", ".remove_samples_from_list", function (e) {
  e.preventDefault();
  // Get the value of the removed sample's data-id
  var sampleId = $(this).closest(".samples__list").data("id");
  // Find and uncheck the corresponding checkbox based on the data-id
  $(".formulas_checkboxes").each(function () {
    if ($(this).val() == sampleId) {
      $(this).prop("checked", false); // Uncheck the checkbox
      $(this)
        .parents(".cmcnt--item-prd")
        .find(".label_wrap")
        .text("Order a sample"); // Reset the label text
      $(this).parents(".prod_Checkbox").removeClass("active-checkbox");
    }
  });
  $(this).closest(".samples__list").remove();
  // Check if the sample_side-lists has items and hide the drawer if empty
  toggleDrawerVisibility();
});
// Function to toggle the visibility of the drawer based on the number of items
function toggleDrawerVisibility() {
  if ($(".sample_side-lists").children().length === 0) {
    $(".simple_drawer-wraper").hide();
    $("body").removeClass("dialog-show"); // Hide the drawer if no items
  } else {
    $(".simple_drawer-wraper").show();
    $("body").addClass("dialog-show"); // Show the drawer if there are items
  }
}
// When the user clicks on the "Add to Cart" button
$(document).on("click", ".multiadd_to-cart", function () {
  var items = [];
  $(".samples__list").each(function () {
    var $el = $(this),
      id = $el.attr("data-id"),
      qty = 1,
      myObj = {
        id: id,
        quantity: qty,
      };
    items.push(myObj);
  });

  let formData = {
    items: items,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      window.location.href = "/pages/colors-and-materials"; // Redirect to cart after adding items
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

$(document).on("change", `[name="sort_by"]`, function () {
  var $el = $(this);
  setTimeout(function () {
    console.log($el.val(), "<<<<<");
    updateFilterAndFetchData();
  }, 1000);
});

$(document).on("click", ".side_loader__close", function (e) {
  e.preventDefault();
  $("body").removeClass("dialog-show");
});
// Check if products are in the cart and update the checkboxes on page load
function checkCartForItems() {
  // Fetch cart contents
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      // Get all items in the cart
      var cartItems = cartData.items;

      // Loop through each item in the cart and update checkboxes and labels
      $(".formulas_checkboxes").each(function () {
        var $checkbox = $(this);
        var checkboxId = $checkbox.val();

        // Check if this checkbox's value (product ID) is in the cart
        var isInCart = cartItems.some((item) => item.id == checkboxId);

        // If the item is in the cart, check the checkbox and update the label
        if (isInCart) {
          $checkbox.prop("checked", true); // Check the checkbox
          $checkbox
            .parents(".cmcnt--item-prd")
            .find(".label_wrap")
            .html("Added"); // Change the label to "Added"
          $checkbox.parents(".prod_Checkbox").addClass("active-checkbox");
          // Optionally, add the item to the sample list
          var itemInCart = cartItems.find((item) => item.id == checkboxId);
          console.log(itemInCart, "itemInCart>>>>");
          var newSampleHTML = `<div class="samples__list" data-id="${itemInCart.id}">
                                        <div class="samples_list__samples_img">
                                            <img src="${itemInCart.image}" alt="${itemInCart.title}">
                                        </div>
                                        <div class="samples_list__samples_title">${itemInCart.title}</div>
                                        <a href="#" class="remove_samples_from_list">x</a>
                                      </div>`;
          $(".sample_side-lists").append(newSampleHTML);
        }
      });

      // Ensure drawer visibility based on the sample list
      toggleDrawerVisibility();
    })
    .catch((error) => console.error("Error fetching cart data:", error));
}

const formatValue = (value) => (value ? value.replace(/\s/g, "+") : '""');

// Function to construct filter string based on the values of filters and sliders
const buildFilterString = () => {
  // Get values from sliders and inputs
  const length_value = $("#length_slider").val();
  const width_value = $("#width_slider").val();
  const sortVal = $(`[name="sort_by"]:checked`).val() || $("#SortBy").val();
  const numberOfPerson = $("#person_slider").val();

  // Get checkbox values
  const coversChecked = $('[name="covers"]').is(":checked");
  const legChecked = $('[name="legs"]').is(":checked");
  const drawersChecked = $('[name="drawers"]').is(":checked");
  const bed_useChecked = $('[name="bed_use"]:checked')
    .map(function () {
      return $(this).val(); // Get the value of the checked checkbox
    })
    .get();
  // Build the filters array with mandatory values
  // let filters = [
  //   // `filter.p.m.custom.length=${formatValue(length_value)}`,
  //   // `filter.p.m.custom.width=${formatValue(width_value)}`,
  //   // `filter.p.m.custom.number_of_persons=${formatValue(numberOfPerson)}`,
  //   `custom-filter=length:${length_value},width:${width_value},person:${numberOfPerson}`,
  // ];

  let filters = [
    // `filter.p.m.custom.length=${formatValue(length_value)}`,
    // `filter.p.m.custom.width=${formatValue(width_value)}`,
    // `filter.p.m.custom.number_of_persons=${formatValue(numberOfPerson)}`
  ];

  if (length_value != null && width_value != null && numberOfPerson != null) {
    filters.push(
      `custom-filter=length:${length_value},width:${width_value},person:${numberOfPerson}`
    );
  }

  if (!filters.length) {
    return "";
  }

  $("#width_slider_value").val(width_value);
  $("#length_slider_value").val(length_value);
  $("#person_slider_value").val(numberOfPerson);
  // Add filters based on checkbox states
  if (coversChecked) {
    const covers = $('[name="covers"]').val();
    filters.push(`filter.p.m.custom._removable_covers=${formatValue(covers)}`);
  }

  if (legChecked) {
    const legs = $('[name="legs"]').val();
    filters.push(`filter.p.m.custom.legs=${formatValue(legs)}`);
  }

  if (drawersChecked) {
    const drawers = $('[name="drawers"]').val();
    filters.push(
      `filter.p.m.custom._additional_storage_spaces=${formatValue(drawers)}`
    );
  }
  if (bed_useChecked.length > 0) {
    filters.push(`filter.p.m.custom.bed_use=${bed_useChecked}`); // Join values with comma
  }
  // Always add 'sort_by' at the end of the filter array
  filters.push(`sort_by=${sortVal ? encodeURIComponent(sortVal) : '""'}`);

  return filters.join("&");
};

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Function to update the URL and fetch data
const updateFilterAndFetchData = () => {
  // Build the filter string
  const filterString = buildFilterString();
  if (filterString == "") {
    return;
  }

  // Construct the final URL (no view=custom-collection parameter)
  const new_link = `${window.location.pathname}?${filterString}&view=ajax`;
  const window_new_link = `${window.location.pathname}?${filterString}`;
  console.log("Final filter string:", new_link);

  // Update the browser URL without reloading the page
  window.history.pushState(null, "", window_new_link);

  setTimeout(function () {
    // Fetch the filtered data
    getDataWithType(new_link, "text")
      .then((html) => {
        const doc = document.createElement("div");
        doc.innerHTML = html;
        const target = doc.querySelector(".template--collection--ajax11");
        const innerContent = target ? target.innerHTML : ""; // Ensure target exists

        // Update the DOM with the new content
        $(".custom-template--collection--ajax").html(innerContent);
        var custom_filter = getParameterByName("custom-filter");
        const parsedValues = parseParameters(custom_filter);

        console.log("innerContent>>>", {
          parsedValues,
          l: parsedValues.length,
          p: parsedValues.person,
          w: parsedValues.width,
        });

        const griditemss = $("#product-grid li").filter(function () {
          return (
            $(this).attr("person_q") >= parsedValues.person &&
            $(this).attr("length_q") <= parsedValues.length &&
            $(this).attr("width_q") <= parsedValues.width
          );
        });

        // Hide all items, then directly show the filtered ones
        $("#product-grid li").hide();
        griditemss.show();

        console.log(griditemss, "<<<<griditemss");

        $("#ProductCountDesktop").html(
          `${$(target).find("li").length} products`
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error); // Log any error in the request
      });
  }, 0);
};

function parseParameters(paramString) {
  // Split the string into key-value pairs
  const pairs = paramString.split(",");

  // Convert pairs into an object
  const result = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split(":");
    result[key] = isNaN(value) ? value : Number(value); // Convert numeric values
  });

  return result;
}

// Attach the optimized function to all sliders
$("#length_slider, #width_slider, #person_slider").on(
  "input",
  updateFilterAndFetchData
);

// Attach the optimized function to all checkboxes
$('[name="covers"], [name="legs"], [name="drawers"]').click(
  updateFilterAndFetchData
);
$('[name="bed_use"]').on("change", updateFilterAndFetchData);
// if ($("body").attr("data-template") == "collection") updateFilterAndFetchData();

async function getDataWithType(url = "", type = "json") {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    switch (type) {
      case "json":
        return response.json();
      case "text":
        return response.text();
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error; // Re-throw to allow further handling if necessary
  }
}

window.addEventListener("load", () => {
  try {
    var $videoWrap = $(".custom-video-wrap");
    var videoWrapOffsetTop = $videoWrap.offset().top;
    var maxZoom = 1.13; // Maximum zoom level (you can adjust this value)

    // Function to handle sticky behavior and zoom effect
    function handleScroll() {
      var scrollTop = $(window).scrollTop();
      var elementTop = $videoWrap.offset().top;
      var elementBottom = elementTop + $videoWrap.outerHeight();
      var viewportBottom = scrollTop + $(window).height();

      // Check if the element is in the viewport
      if (scrollTop >= videoWrapOffsetTop) {
        // Add sticky class when section reaches the top
        $videoWrap.addClass("sticky");
      } else {
        // Remove sticky class when it's not at the top anymore
        $videoWrap.removeClass("sticky");
      }

      // Zoom effect when section is sticky and in viewport
      if (scrollTop >= videoWrapOffsetTop && scrollTop < elementBottom) {
        // Calculate the zoom factor (scale only, no width change)
        var zoomFactor = (scrollTop - videoWrapOffsetTop) / 1000; // Adjust zoom speed
        var newScale = 1 + zoomFactor; // Increase scale from 1 to a zoomed-in factor

        // Limit the zoom factor to maxZoom
        newScale = Math.min(newScale, maxZoom);

        // Apply the scaling using transform
        $videoWrap.css({
          transform: "scale(" + newScale + ")",
        });
      }
      if (
        scrollTop >
        videoWrapOffsetTop + $videoWrap.outerHeight() - $(window).height()
      ) {
        // Remove sticky class and stop zooming when section is no longer in the viewport
        $videoWrap.removeClass("sticky");
      }
    }

    // Handle the scroll event
    $(window).on("scroll", function () {
      handleScroll();
    });
    handleScroll();
  } catch (error) {}

  // $(".vc--video").click(function () {
  //   this.paused ? this.play() : this.pause();
  // });
});

$(".thumbnail-list_item--variant").eq(0).show();
$(".thumbnail-list_item--variant").eq(1).show();

window.onVariantChange = (variant) => {
  console.log(variant, "variant Callback");
  var variant_sku = variant.sku;
  $(".prd__sku").text(variant_sku);
  setTimeout(function () {
    $(".thumbnail-list_item--variant").eq(0).show();
  }, 1);
  var image_alt = variant.featured_media.alt;
  setTimeout(function () {
    var html = $(`.thumbnail-list__item[data-alt="${image_alt}"]`)
      .eq(1)
      .prop("outerHTML");
    console.log(html, image_alt);
    var $newElement = $(html)
      .show()
      .addClass("thumbnail-list_item--variant new-thumbnail-list_item");
    $(".thumbnail-list_item--variant:first").after($newElement);
    $(".hide_media").hide();
    $(".thumbnail-list_item--variant").eq(1).show();
    $(".new-thumbnail-list_item").not(":first").remove();


     if ($('.toggle__input').prop('checked')) {
        console.log('checked on page load');
        $(".product-form__input--swatch .custom_attr_wrap").each(function() {
            var avlValue = $(this).attr("data-avl");
            if (avlValue === "true") {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    } else {
        $('.custom_attr_wrap').show(); // Ensure all elements are shown if unchecked on load
    }
  }, 1000);
   
};


document.querySelectorAll('#Search-In-Modal').forEach(function(input) {
  input.addEventListener('input', function () {
    const form = this.closest('.search-modal__form');
    const label = form ? form.querySelector('.field__label') : null;

    if (this.value.trim() !== '') {
      this.removeAttribute('placeholder');
      if (label) label.style.display = 'none';
    } else {
      if (label) label.style.display = '';
    }
  });
});
